import {
  getCurrentZohoLead,
  getFilteredLeads,
  getFilteredResubmits,
  getLeadById,
  getLeadsAll,
} from '../api/LeadsApi';
import useBaseQuery from '../hooks/useBaseQuery';
import {
  AdminFilters,
  FilteredLeads,
  IBaseQueryOptions,
  ILead,
  ILeadFilteringOptions,
} from '../types';
import IQueryKeys from '../types/IQueryKeys';

export const useLeadsAllQuery = (params: ILeadFilteringOptions) => {
  return useBaseQuery([IQueryKeys.leadsAllKey, params], () => getLeadsAll(params), {});
};

export const useFilteredLeadsQuery = (
  filters: AdminFilters,
  options?: IBaseQueryOptions<FilteredLeads>,
) => {
  return useBaseQuery([IQueryKeys.filteredLeadsKey, filters], () => getFilteredLeads(filters), {
    ...options,
  });
};
export const useFilteredResubmitsQuery = (filters: AdminFilters) => {
  return useBaseQuery(
    [IQueryKeys.filteredResubmitsKey, filters],
    () => getFilteredResubmits(filters),
    {},
  );
};

export const useLeadByIdQuery = (id: number, options?: IBaseQueryOptions<ILead>) => {
  return useBaseQuery([IQueryKeys.leadsByIdKey, id], () => getLeadById(id), { ...options });
};

export const useCurrentZohoLead = () => {
  return useBaseQuery([IQueryKeys.currentZohoLead], () => getCurrentZohoLead());
};
